export const roles = {

    // chaves em lowercase para compatibilidade
    roleAdmin: 'Administrador',
    roleUser: 'Usuário',
    roleManager: 'Gerente',
    roleReporter: 'Relator',
};



// Importar as permissões do novo sistema
export { FEATURE, ACTION, PERMISSIONS, FEATURES_LIST } from './permissions';